import { FileListItemContent } from '../FileListItemContent'
import { ListItem } from '../ListItem'

function FileListItem(props) {
  return <ListItem {...props} Content={FileListItemContent} />
}

export default FileListItem
